import React from 'react'
import PropTypes from 'prop-types'

function FlexRow({ children, ...rest }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }} {...rest}>
      {children}
    </div>
  )
}

FlexRow.propTypes = {
  children: PropTypes.node.isRequired,
}

export default FlexRow
